import { Component, OnInit } from '@angular/core';
import { GungTroubleshootingBaseViewComponent } from '../gung-troubleshooting-base-view/gung-troubleshooting-base-view.component';
import { GungTroubleshootingProductDebug, GungTroubleshootingService } from '../../../services/gung-troubleshooting/gung-troubleshooting.service';
import { OptionsListMulti } from 'gung-common';
import { GungFlowService } from '../../../services/gung-flow/gung-flow.service';
import { UsersService } from '../../../services/users/users.service';
import { first, forkJoin } from 'rxjs';
import { AuthService } from '../../../services/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-gung-troubleshooting-product-view',
  templateUrl: './gung-troubleshooting-product-view.component.html',
  styleUrl: './gung-troubleshooting-product-view.component.scss',
  standalone: false
})
export class GungTroubleshootingProductViewComponent extends GungTroubleshootingBaseViewComponent implements OnInit {
  protected productId: string;
  protected selectedFlowId: string;
  protected selectedUsername: string;

  protected flowOptions: OptionsListMulti[];
  protected userOptions: OptionsListMulti[];

  protected productDebugData: GungTroubleshootingProductDebug;
  protected productBlockedExtraText: string = this.gungTroubleshootingService.getErpSpecificProductBlockedTranslateTag();
  protected loading: boolean = false;

  constructor(
    protected gungTroubleshootingService: GungTroubleshootingService,
    protected gungFlowService: GungFlowService,
    protected usersService: UsersService,
    protected authService: AuthService,
    protected translateService: TranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    this.updateFlowOptions();
    this.updateUserOptions();
  }

  protected updateFlowOptions(): void {
    forkJoin({
      gungFlows: this.gungFlowService.getGungFlows().pipe(first()),
      selectedGungFlow: this.gungFlowService.getSelectedFlow().pipe(first())
    }).subscribe(({ gungFlows, selectedGungFlow }) => {
      this.selectedFlowId = selectedGungFlow.id;
      this.flowOptions = gungFlows.map(f => {
        return {
          id: f.id,
          name: f.name + (f.id === selectedGungFlow.id ? ` (${this.translateService.instant('DEFAULT_SELECTED')})` : ''),
          selected: f.id === selectedGungFlow.id
        };
      }).sort((a, b) => {
        if (a.id === selectedGungFlow.id) {
          return -1;
        } else if (b.id === selectedGungFlow.id) {
          return 1;
        } else {
          return 0;
        }
      });
    });
  }

  protected setSelectedFlowId(selected: string[]): void {
    this.selectedFlowId = selected[0] || undefined;
  }

  protected updateUserOptions(): void {
    forkJoin({
      users: this.usersService.getAllUsers().pipe(first()),
      currentUser: this.authService.getCurrentUser().pipe(first())
    }).subscribe(({ users, currentUser }) => {
      this.selectedUsername = currentUser.username;
      this.userOptions = users.map(u => {
        return {
          id: u.username,
          name: u.name + (u.username === currentUser.username ? ` (${this.translateService.instant('DEFAULT_SELECTED')})` : ''),
          selected: u.username === currentUser.username
        };
      }).sort((a, b) => {
        if (a.id === currentUser.username) {
          return -1;
        } else if (b.id === currentUser.username) {
          return 1;
        } else {
          return 0;
        }
      });
    });
  }

  protected setSelectedUsername(selected: string[]): void {
    this.selectedUsername = selected[0] || undefined;
  }

  protected debugProduct(): void {
    this.loading = true;
    this.gungTroubleshootingService.debugProduct(this.productId, this.selectedUsername, this.selectedFlowId).pipe(first()).subscribe(res => {
      this.productDebugData = res;
      this.loading = false;
    });
  }
}
